import size from 'lodash/size';
import find from 'lodash/find';
import forOwn from 'lodash/forOwn';
import modelTree from "~/selectors/modelTree";
import loadModels from "~/reducers/helpers/loadModels";
import identify from "~/identify";

const ensureRelatedModelsAreLoaded = (loadedModels, props) => {
    let { parentModelId, modelName, getModelOrNull, getSubviewsByModelName, getRelationshipFieldsByModelName } = props;

    let relatedFields = getRelationshipFieldsByModelName(modelName);

    if(!size(relatedFields)) { return loadedModels; }

    let tree = modelTree(loadedModels),
        childModels = tree.getChildren(parentModelId),
        modelsToLoad = [];  

    forOwn(relatedFields, ({model}) => {
        if(!find([...childModels, ...modelsToLoad], { modelName: model, hasForeignFieldRelation: true })) {
            modelsToLoad.push({
                modelId: tree.getTreeId(model, parentModelId),
                parentModelId: parentModelId,
                modelName: model,
                data: {
                    hasForeignFieldRelation: true,
                    view: identify.VIEW_EDIT,
                }
            });
            
        }
    });

    return loadModels(loadedModels, { models: modelsToLoad, getSubviewsByModelName, getModelOrNull, getRelationshipFieldsByModelName} );
};

export default ensureRelatedModelsAreLoaded;